/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { GlobalStyles } from '@mui/material';
import CustomModal from '../components/common/CustomModal';
import {
  manageRosterStatusInfoModalClasses,
  manageRosterStatusInfoModalPortalSlotStyles
} from './styles/manageRosterStatusInfoModalStyles';

const ManageRosterStatusInfoModal = ({
  open,
  onClose,
  textInfo
}) => {
  const classes = manageRosterStatusInfoModalClasses;

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.modalPaper,
        content: classes.modalContent,
        closeButton: classes.modalCloseButton
      }}
    >
      <GlobalStyles styles={manageRosterStatusInfoModalPortalSlotStyles} />
      <header className={classes.modalHeader}>
        <h2 className={classes.modalTitle}>{textInfo.title}</h2>
      </header>
      <div className={classes.modalBody}>
        <div className={classes.modalText}>
          <p className={classes.modalParagraphFirst}>{textInfo.bodyParagraph1}</p>
          <p className={classes.modalParagraph}>{textInfo.bodyParagraph2}</p>
        </div>
      </div>
    </CustomModal>
  );
};

ManageRosterStatusInfoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  textInfo: PropTypes.shape({
    title: PropTypes.string.isRequired,
    bodyParagraph1: PropTypes.string.isRequired,
    bodyParagraph2: PropTypes.string.isRequired
  }).isRequired
};

export default ManageRosterStatusInfoModal;
